// Lazy loading Image component for web
// Uses native browser lazy loading when available, falls back to immediate loading
import React, { useState } from 'react';
import { Image, ImageProps, Platform } from 'react-native';

interface LazyImageProps extends Omit<ImageProps, 'source'> {
  source: { uri: string } | number;
  fallback?: { uri: string } | number;
}

const LazyImage: React.FC<LazyImageProps> = ({
  source,
  fallback,
  style,
  ...props
}) => {
  const [hasError, setHasError] = useState(false);

  // For web, use native lazy loading via loading attribute
  // React Native Web's Image component should pass through HTML attributes
  const imageProps: any = {
    ...props,
    source: hasError && fallback ? fallback : source,
    style,
    onError: () => {
      if (fallback && !hasError) {
        setHasError(true);
      }
      if (props.onError) {
        props.onError({} as any);
      }
    },
  };

  // Add loading="lazy" for web - React Native Web should pass this to the img tag
  if (Platform.OS === 'web' && typeof source === 'object' && 'uri' in source) {
    // @ts-ignore - web-specific loading attribute
    imageProps.loading = 'lazy';
  }

  return <Image {...imageProps} />;
};

export default LazyImage;

